import { useEffect } from 'react';
import {
  CustomSingleViewIcon,
  CustomSplitViewIcon,
} from '../../components/ScanCompare/ScanCompareView/styles';
import { CompareModeEnum, useCompareStore } from './useCompareStore';
import { useCameraStore } from '../SyncedControls/useCameraStore';
import { CanvasControlButtonGroup } from '../CanvasControls/CanvasControlButtonGroup';

export const CompareControlButtons = () => {
  const { compareMode, setCompareMode } = useCompareStore();
  const { setSynced } = useCameraStore();

  useEffect(() => {
    if (compareMode === CompareModeEnum.Single) {
      setSynced(false);
    }
  }, [compareMode, setSynced]);

  return (
    <CanvasControlButtonGroup
      title='Compare mode'
      value={compareMode}
      onChange={(value) => setCompareMode(value as CompareModeEnum)}
      options={[
        {
          value: CompareModeEnum.Single,
          label: (
            <>
              <CustomSingleViewIcon /> Single view
            </>
          ),
        },
        {
          value: CompareModeEnum.Dual,
          label: (
            <>
              <CustomSplitViewIcon /> Split view
            </>
          ),
        },
      ]}
    />
  );
};
